export enum MessageEventPriority {
  Silent = 0,
  Activity = 1,
  Info = 2,
  Action = 3,
  Error = 4,
}
